import '@styles/Banner/ConfirmacionDetalle.scss';
import { Text } from '@lana-ui/common';
import ConfirmacionNewsletters from './ConfirmacionNewsletters';
import ConfirmacionDescripcionProductos from './ConfirmacionDescripcionProductos';

const ConfirmacionDetalle = ({ beneficios, tieneClubLN }) => {
    return (
        <>
            <Text className="confirmacion --twoxs">
                <ConfirmacionDescripcionProductos beneficios={beneficios} tieneClubLN={tieneClubLN} />
                <ConfirmacionNewsletters />
            </Text>
        </>);
};

export default ConfirmacionDetalle;